<template>
  <div>
    <div class="page-title mb-30">Nodes</div>
    <div class="page-content max-w-1000" v-loading="loading">
      <div class="section-title mb-20">
        <span class="right-float">
          <img src="@/assets/filter.svg" />
          <el-input
            v-model="filter"
            size="mini"
            class="search-input filter-input"
            placeholder="filter by node mac"
          ></el-input>
        </span>
      </div>
      <el-table border size="small" :data="displayData">
        <el-table-column
          label="Node"
          prop="macAddress"
          fixed="left"
        ></el-table-column>
        <el-table-column label="Environment" prop="environment">
          <template slot-scope="scope">
            <el-select
              v-model="scope.row.newEnvironment"
              placeholder="please select"
              size="mini"
              @change="changeEnvironment(scope.row)"
            >
              <el-option
                v-for="item in environmentOptions"
                :key="item"
                :label="item"
                :value="item"
              >
              </el-option>
            </el-select>
          </template>
        </el-table-column>
        <el-table-column label="Action" fixed="right">
          <template slot-scope="scope">
            <el-button
              type="success"
              plain
              class="delete-btn mini-btn min-w-80 ml-10"
              @click="reboot(scope.row)"
              >Reboot</el-button
            >
          </template>
        </el-table-column>
      </el-table>
    </div>
  </div>
</template>

<script>
import swal from 'sweetalert'
import ApiService from '@/services/CommonApiService.js'
export default {
  data() {
    return {
      loading: false,
      data: [],
      displayData: [],
      filter: '',
      timer: '',
      environmentOptions: ['Development', 'Staging', 'Beta', 'Production']
    }
  },
  mounted() {
    this.getData()
  },
  watch: {
    filter() {
      if (this.timer) {
        clearTimeout(this.timer)
      }
      this.timer = setTimeout(this.filterNodes, 500)
    }
  },
  methods: {
    getData() {
      this.loading = true
      ApiService.GetNodeList()
        .then(response => {
          this.loading = false
          if (response.data.success) {
            this.data = response.data.data.map(item => {
              return {
                ...item,
                newEnvironment: item.environment
              }
            })
            this.displayData = this.data
          } else {
            swal({
              icon: 'error',
              title: this.$t('text.failed'),
              text: response.data.msg
            })
          }
        })
        .catch(() => {
          this.loading = false
          swal({
            icon: 'error',
            timer: 2000,
            title: this.$t('text.failed')
          })
        })
    },
    filterNodes() {
      this.displayData = this.data.filter(item => {
        return (
          item.macAddress.toLowerCase().indexOf(this.filter.toLowerCase()) > -1
        )
      })
    },
    reboot(item) {
      this.$confirm(
        `You're about to reboot ${item.macAddress}`,
        'Are you sure?',
        {
          confirmButtonText: 'REBOOT',
          cancelButtonText: this.$t('text.cancel').toUpperCase(),
          confirmButtonClass: 'delete-btn',
          cancelButtonClass: 'cancel-btn',
          type: 'warning',
          customClass: 'delete-warning-box',
          showClose: false,
          closeOnClickModal: false
        }
      )
        .then(() => {
          this.handleReboot(item)
        })
        .catch(() => {})
    },
    handleReboot(item) {
      ApiService.UpdateNodeConfig({
        NodeMac: item.macAddress,
        Environment: item.Environment,
        Reboot: true
      })
        .then(response => {
          if (response.data.success) {
            swal({
              icon: 'success',
              timer: 2000,
              title: 'Reboot Successfully'
            })
          } else {
            swal({
              icon: 'error',
              timer: 2000,
              title: 'Reboot Failed',
              text: response.data.msg
            })
          }
        })
        .catch(() => {
          swal({
            icon: 'error',
            timer: 2000,
            title: 'Reboot Failed'
          })
        })
    },
    changeEnvironment(item) {
      this.$confirm(
        `You're about to change ${item.macAddress} environment`,
        'Are you sure?',
        {
          confirmButtonText: 'CHANGE',
          cancelButtonText: this.$t('text.cancel').toUpperCase(),
          confirmButtonClass: 'delete-btn',
          cancelButtonClass: 'cancel-btn',
          type: 'warning',
          customClass: 'delete-warning-box',
          showClose: false,
          closeOnClickModal: false
        }
      )
        .then(() => {
          this.handleChangeEnvironment(item)
        })
        .catch(() => {})
    },
    handleChangeEnvironment(item) {
      ApiService.UpdateNodeConfig({
        NodeMac: item.macAddress,
        Environment: item.newEnvironment,
        Reboot: false
      })
        .then(response => {
          if (response.data.success) {
            swal({
              icon: 'success',
              timer: 2000,
              title: 'Change Successfully'
            })
          } else {
            swal({
              icon: 'error',
              timer: 2000,
              title: 'Change Failed',
              text: response.data.msg
            })
          }
          this.getData()
        })
        .catch(() => {
          swal({
            icon: 'error',
            timer: 2000,
            title: 'Change Failed'
          })
          this.getData()
        })
    }
  },
  beforeDestroy() {
    clearInterval(this.timer)
  }
}
</script>
